import {Box, Typography, Tooltip, Chip} from '@mui/material';

const statusChipStyles = {
    borderRadius: '50%',
    height: '0.875rem',
    width: '0.875rem',
    minWidth: '0.875rem',
    padding: 0,
    marginRight: '0.25rem',
    marginTop: '-0.04rem',
};

export default function MemberJoinStatus({message, displayTime, joiningTime, color}) {
    return (
      <Tooltip
        placement="left"
        title={
            <Box display="flex" gap="0.2rem">
                <Typography sx={{fontSize: '0.75rem'}}>{message}</Typography>
                {
                  displayTime
                  &&
                  <Typography sx={{fontSize: '0.75rem'}}>({joiningTime})</Typography>
                }
            </Box>
        }>
          <Chip color={color} size="small" sx={statusChipStyles}/>
      </Tooltip>
    );
}